import React from 'react';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, Button, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ShowErrors } from 'common/components';
import { ReactHookFormInput } from 'common/components/form/RHF';
import yupResolver from 'common/utils/yupResolver';

import validate from '../validate';

const FirstStepAuthForm = ({
    errorsInitAuth,
    handleShowPassword,
    handleSubmitInitAuth,
    initialValues,
    isLoadingInitAuth,
    onChangePassword,
    showPassword,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    // Wrap onChangePassword to handle react-hook-form's onChange
    const handlePasswordChange = (e) => {
        if (onChangePassword) {
            onChangePassword(e);
        }
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitInitAuth)}>
            <Stack spacing={2}>
                <ReactHookFormInput
                    autoComplete="off"
                    control={control}
                    name="email"
                    placeholder={t('Mail')}
                    type="email"
                    variant="outlined"
                />

                <ReactHookFormInput
                    autoComplete="off"
                    control={control}
                    endAdornmentIcon={
                        showPassword ? <VisibilityOff /> : <Visibility />
                    }
                    handleClickButtonEndAdornment={handleShowPassword}
                    name="password"
                    onChange={handlePasswordChange}
                    placeholder={t('Password')}
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                />

                <ShowErrors
                    errors={errorsInitAuth}
                    severity="error"
                    variant="filled"
                />
            </Stack>

            <Box sx={{ textAlign: 'center', marginTop: 3 }}>
                <Button disabled={isLoadingInitAuth} fullWidth type="submit">
                    {isLoadingInitAuth ? `${t('Loading')}...` : t('Next')}
                </Button>
            </Box>
        </form>
    );
};

FirstStepAuthForm.propTypes = {
    errorsInitAuth: PropTypes.array,
    handleShowPassword: PropTypes.func,
    handleSubmitInitAuth: PropTypes.func,
    initialValues: PropTypes.object,
    isLoadingInitAuth: PropTypes.bool,
    onChangePassword: PropTypes.func,
    showPassword: PropTypes.bool,
};

export default FirstStepAuthForm;
